// extracted by mini-css-extract-plugin
module.exports = {"container":"MainHeading_container__237sU","container--white":"MainHeading_container--white__KKcVw"};